import { NoSSR } from '@/components';
import { getDefaultStaticProps } from '@/utils';
import { QuotePageView } from './QuotePageView';
const QuotePage = () => <NoSSR data-sentry-element="NoSSR" data-sentry-component="QuotePage" data-sentry-source-file="index.page.tsx">
    <QuotePageView data-sentry-element="QuotePageView" data-sentry-source-file="index.page.tsx" />
  </NoSSR>;
export const getStaticProps = getDefaultStaticProps;
export default QuotePage;